export default __webpack_public_path__ + "static/media/Vazir.86fc40c3.ttf";